import { useEffect, useState } from "react";

export default function useActiveViewport() {
  const [activeViewportId, setActiveViewportId] = useState(null);

  function activateViewport(viewportId) {
    setActiveViewportId(viewportId);
  }

  function deactivateViewport() {
    setActiveViewportId(null);
  }

  useEffect(() => {
    function onKeyDown(e) {
      if (e.key === "Escape") {
        deactivateViewport();
      }
    }

    window.addEventListener("keydown", onKeyDown, true);
    return () => window.removeEventListener("keydown", onKeyDown, true);
  }, []);

  return {
    activeViewportId,
    activateViewport,
    deactivateViewport,
    isViewportActive: (viewportId) => activeViewportId === viewportId,
  };
}